<template>
  <VContainer class="pb-12">
    <h1 class="mb-4 title">
      {{ $t('confirmEmail') }}
    </h1>
    <VDivider class="mt-2" />

    <VFlex
      xs12
      sm6
      md4
      class="mx-auto mb"
    >
      <VLayout
        column
        align-center
      >
        <div
          v-if="error !== null"
          class="mt-5 red--text text-center"
        >
          {{ error }}
          <VBtn
            v-if="user"
            color="success"
            :loading="loading"
            @click="resendVerification"
          >
            {{ $t('resend') }}
          </VBtn>
        </div>
        <div v-if="error === null">
          {{ $t('confirmingEmail') }}
          <VProgressCircular indeterminate />
        </div>
      </VLayout>
    </VFlex>
  </VContainer>
</template>

<script>
import ValidationMixin from '../mixins/ValidationMixin';
import RecaptchaMixin from '../mixins/RecaptchaMixin';
import User from '../orm/models/User/User';

export default {
  name: 'VerifyEmail',
  metaInfo() {
    return {
      title: this.$t('confirmEmail'),
    };
  },
  mixins: [ValidationMixin, RecaptchaMixin],
  props: {
    user: {
      required: true,
      validator(v) {
        return v instanceof Object || v === null;
      },
    },
  },
  data() {
    return {
      expires: null,
      id: null,
      signature: null,
      loading: false,
      error: null,
    };
  },
  created() {
    this.verifyEmail(this.$route.query);
  },
  methods: {
    async verifyEmail(payload) {
      try {
        await User.api().verifyEmail(payload);
        if (User.getAuthUser()) {
          await User.update({ id: User.getAuthUser().id, emailVerified: true });
        }
        await this.$router.push('/');
      } catch (e) {
        this.error = this.$t('notConfirmed');
      }
    },
    resendVerification() {
      this.withApiErrorHandling(
        async () => {
          const recaptchaToken = await this.getRecaptchaToken('userResendVerification');
          await User.api().verifyEmailResend({ recaptchaToken });
          this.$toast.info(this.$t('verificationSent'));
        },
        (e) => this.$toast.error(e.message),
      );
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  confirmEmail: Confirm e-mail address
  confirmingEmail: Confirming e-mail address
  notConfirmed:  Cannot verify e-mail address
  resend: Resend
  verificationSent: Verification e-mail sent
</i18n>

<i18n locale="ru" lang="yaml">
  confirmEmail: Подтверждение адреса электронной почты
  confirmingEmail: Подтверждаем E-mail адрес
  notConfirmed: Не удалось подтвердить E-mail адрес
  resend: Отправить письмо заново
  verificationSent: Письмо для подтверждения E-mail отправлено
</i18n>
